import { Grid } from "@mui/material";
import React from "react";
import { withTranslation } from "react-i18next";
import logger from "../../services/logger";
import PagingAndSorting from "../common/pagingAndSorting";
import Add from "../common/add";
import FormDialog from "../common/formDialog";
import designationService from "./designation.service";
import DesignationTable from "./designationTable.page";
import DesignationFormPage from "./designationForm.page";

class Designations extends PagingAndSorting {
  state = {
    programs: [],
    sortColumn: { path: "id", order: "asc" },
    page: 0,
    rowsPerPage: 10,
    expanded:""
  };

  getAll = async () => {
    try {
      const { data} = await designationService.getAll();
      
      this.setState({ data });
    } catch (ex) {
      console.log("designations ", ex);
    }
  };

  deleteById = async (id) => {
    try {
      await designationService.deleteById(id);
      await this.getAll();
    } catch (ex) {
      logger.error(ex);
    }
  };

  componentDidMount() {
    this.getAll();
  }

  onConfirmOk = (id) => {
    this.deleteById(id);
  };

  closeDialog = () => {
    this.setState({ dialogOpen: false });
    this.getAll();
  };


  render() {
    const {  data,dialogOpen,id } = this.state;
    const { t,type,heading } = this.props;
    return (
      <React.Fragment>
        <Grid container>
          <Grid
            container
            item
            xs={12}
            direction="row-reverse"
          >           
            <Add onAdd={this.handleAdd} item={{id:"new"}} title={t("New Designation")}/>
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={12}>
            &nbsp;
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={12}>
          <DesignationTable
              heading={"List of Designations"}
              data={data}
              // sortColumn={sortColumn}
              onSort={this.handleSort}
              onDelete={this.handleDelete}
              onEdit={this.handleEdit}
            />
           

          </Grid>
        </Grid>
        {this.renderDeleteConfirmDialog(
          t("Delete Confirmation"),
          t("Are you sure you want to delete?")
        )}

      {dialogOpen && (
          <FormDialog
            id="education-dialog"
            keepMounted
            title={"Designation Details"}
            content={
              <DesignationFormPage
               
                id={id ? id : "new"}
                onSave={this.closeDialog}
              />
            }
            open={dialogOpen}
            onClose={() => this.setState({ dialogOpen: false })}
          />
        )}

      </React.Fragment>
    );
  }
}

export default withTranslation(["designation"])(Designations);
